import React, { useRef } from 'react';
import useDraggableScroll from 'use-draggable-scroll';
import Styled from './styles';
import { SidebarSubTypeFilter } from './SidebarSubTypeFilter';
import { ANNOUNCEMENTS_TYPE } from '../../../../constants/ANNOUNCEMENT';

export const SubFilters = ({
  t,
  announcementsGroup,
  filterType,
  setSubSelectedFilter,
  selectedSubFilter,
  setIsMouseDown,
}) => {
  const subTypeFilterRef = useRef(null);
  const { onMouseDown: onSubTypeFilterMouseDown } = useDraggableScroll(subTypeFilterRef);

  const setSubFilter = (name: string) => {
    setSubSelectedFilter(name);
  };

  const scrollSubFilter = (event) => {
    onSubTypeFilterMouseDown(event);
    setIsMouseDown(true);
  };

  return (
    <Styled.TypeFilter ref={subTypeFilterRef} onMouseDown={scrollSubFilter}>
      <li>
        <SidebarSubTypeFilter
          type={ANNOUNCEMENTS_TYPE.ALL}
          onSelect={setSubFilter}
          selectedSubFilter={selectedSubFilter}
        >
          {t('announcements_filter_all')}
        </SidebarSubTypeFilter>
      </li>

      {Object.entries(announcementsGroup[filterType]).map(([label, announcements]) => (
        <li key={label}>
          <SidebarSubTypeFilter
            type={label}
            onSelect={setSubFilter}
            selectedSubFilter={selectedSubFilter}
          >
            {label}
            {Array.isArray(announcements) && (
              <Styled.AnnouncementCount>{announcements?.length}</Styled.AnnouncementCount>
            )}
          </SidebarSubTypeFilter>
        </li>
      ))}
    </Styled.TypeFilter>
  );
};
